"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerControl = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var ContainerControl = function (props) {
    var children = props.children, className = props.className, _a = props.loading, loading = _a === void 0 ? false : _a;
    return loading ? (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "xlarge" }))) : (react_1.default.createElement("div", { className: "flex justify-center" },
        react_1.default.createElement("div", { className: "container ".concat(className) }, children)));
};
exports.ContainerControl = ContainerControl;
